import React from 'react'
import ReactDOM from 'react-dom/client'
import AuthSessionGate from './AuthSessionGate.tsx'
import StrategyRadarApp from './StrategyRadarApp.tsx'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthSessionGate>
    <React.StrictMode><StrategyRadarApp /></React.StrictMode>
  </AuthSessionGate>
)
